<div class="form-step-field__options-editor" [formGroup]="fieldGroup">
	<div class="form-step-field__options-list" formArrayName="options">
		@for (opt of optionsArray.controls; track trackRichOption(oi); let oi = $index) {
			<div class="form-step-field__rich-option-row" [formGroupName]="oi">
				<div class="form-step-field__rich-option-editor" [id]="'form-step-option-' + oi">
					<tec-form-group [errorMsg]="optionLabelErrorMessage(oi)">
						<tec-text-editor
							[value]="readEditorValue(oi)"
							[placeholder]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.OPTION_COMMENT_PLACEHOLDER' | translate"
							[showAlign]="false"
							[showlist]="false"
							[showLink]="true"
							[showAttachment]="false"
							(valueChange)="onEditorValueChange(oi, $event)"
						/>
					</tec-form-group>
				</div>

				<tec-button-icon
					[icon]="'icon-trash'"
					[type]="'default'"
					(clickEvent)="removeOption(oi)"
				></tec-button-icon>
			</div>
		}
	</div>

	<tec-link [label]="'BUTTON.ADD' | translate" (click)="addOption()" />
</div>
